<template lang="pug">
  b-popover(
    :target="target"
    triggers="click blur"
    @keydown.esc="closePopover"
    placement="auto"
  )
    template(v-if="facilitiesData.length")
      ul
        li(v-for="item in facilitiesData")
          span {{ item[field] }}
    template(v-else)
      span {{ placeholder }}

    template(v-if="isRoomPopover")
      hr
      .options
        .direction
          span {{ $t('room.direction') }}
          span.delimiter :
          span {{ translateDirection(roomData.direction) }}
        .renovation-date-interior
          span {{ $t('room.renovation_interior') }}
          span.delimiter :
          span {{ localizedDate(roomData.renovation_date_interior) }}
        .renovation-date-wet
          span {{ $t('room.renovation_wet') }}
          span.delimiter :
          span {{ localizedDate(roomData.renovation_date_wet) }}

</template>

<script>
  import localizeDate from '@/mixins/localize-date'

  export default {
    mixins: [localizeDate],

    props: {
      facilitiesData: {
        type: Array,
        default() {
          return []
        }
      },
      field: {
        type: String,
        default: ''
      },
      target: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '—'
      },
      isRoomPopover: {
        type: Boolean,
        default() {
          return false
        }
      },
      roomData: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    mounted() {
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          this.$root.$emit('bv::hide::popover')
        }
      })
    },

    methods: {
      translateDirection(direction) {
        if (direction) {
          return this.$t(`directions.${direction}`)
        } else {
          return '—'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.popover {
  min-width: 460px !important;

  .popover-body > div {
    ul {
      column-count: 2;
      padding-top: 5%;

      li {
        color: #008bd0;
        font-size: 15px;
        letter-spacing: 0;
        line-height: 32px;
        margin-right: 5px;

        span {
          color: #313541;
          font-size: 13px;
        }
      }
    }
  }

  .options {
    padding: 10px;

    .delimiter {
      margin-right: 5px;
    }
  }
}
</style>
